import Compressor from 'compressorjs'

export const MODULE_NAME = 'AssetConditionVoucher'
export const BASE_PATH = '/asset-condition-voucher'

export const hasPermission = (authUser, permission) => {
  if (!authUser) return false
  if (authUser.superAdmin) return true
  return (authUser.roles || []).some((role) => ((role && role.access) || []).some((entry) =>
    entry && entry.name === MODULE_NAME && (entry.permissions || []).includes(permission)))
}

// Same quality steps as the Asset Stock Taking photo upload
export const compressImage = (file) => new Promise((resolve) => {
  try {
    const quality = file.size >= 2000000 ? 0.1 : file.size >= 500000 ? 0.3 : file.size >= 200000 ? 0.5 : 0.8
    // eslint-disable-next-line no-new
    new Compressor(file, {
      quality,
      success: (result) => resolve(new File([result], file.name || `${Date.now()}.jpeg`, { type: result.type })),
      error: () => resolve(file)
    })
  } catch (e) {
    resolve(file)
  }
})

export const getCurrentPosition = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error('Geo location is not supported on this device'))
    return
  }
  navigator.geolocation.getCurrentPosition(
    (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude, accuracy: pos.coords.accuracy }),
    (err) => reject(new Error(err && err.code === 1
      ? 'Location permission denied. Please allow location access and try again.'
      : 'Unable to get your location. Please try again.')),
    { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
  )
})

// New QR codes are URLs whose 4th path segment is the QR id; old ones carry ?assetCode=
export const parseQrText = (text) => {
  const value = String(text || '').trim()
  if (!value) return null
  if (value.includes('assetCode=')) {
    return { assetCode: decodeURIComponent(value.split('assetCode=').pop().split('&')[0]) }
  }
  try {
    const url = new URL(value)
    const qrId = url.pathname.split('/')[3]
    return qrId ? { qrId } : null
  } catch (e) {
    // Plain text - treat as an asset code
    return { assetCode: value }
  }
}

export const assetLabel = (asset) => {
  if (!asset) return ''
  const parts = [asset.assetCode]
  if (asset.assetModel && asset.assetModel.name) parts.push(asset.assetModel.name)
  return parts.join(' - ')
}

export const assetPlace = (asset) => {
  if (!asset) return ''
  return [asset.location && asset.location.name, asset.client && asset.client.name].filter(Boolean).join(' / ')
}

export const idOf = (value) => (value && (value._id || value)) || undefined
